import React from "react";
import LegalPage from "../../components/legal-information/LegalPage";
import barrierefreiheit from "../../content/barrierefreiheit";

const Impressum = () => {
  return <LegalPage content={barrierefreiheit} />;
};

export default Impressum;